<div class="container">
  <app-breadcrumb [url]="goback"></app-breadcrumb>

  <div>
    <div class="title">
      <h2>Usuários</h2>
    </div>
  </div>

  <form #form="ngForm" novalidate>
    <!-- <mat-expansion-panel [expanded]="true">

      <mat-expansion-panel-header>
        <h3>Filtrar</h3>
      </mat-expansion-panel-header> -->

    <!-- <div fxLayout="row" fxLayout.lt-md="column"> -->
    <!-- <div fxLayout="row" fxLayout.lt-md="column"> -->
    <!-- <mat-form-field appearance="outline" fxFlex="auto">
          <mat-label>Tipo de Usuário</mat-label>
          <mat-select [(ngModel)]="filters.userType" name="filterUserType">
            <mat-option [value]="0">Todos</mat-option>
            <mat-option *ngFor="let userType of optionsUserType" [value]="userType.id">
              {{ userType.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="100%">
          <mat-label>Nome</mat-label>
          <input matInput type="text" placeholder="Nome" [(ngModel)]="filters.userName" name="filterUserName">
        </mat-form-field> -->
    <!-- </div> -->
    <!-- </div> -->
    <mat-card>
      <mat-card-content>
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutAlign.lt-md="space-between center"
          class="title__sub-title"
        >
          <mat-icon class="icons__info">search</mat-icon>
          <div>Pesquisa</div>
        </div>

        <div fxLayout="row" fxLayout.lt-md="column">
          <mat-form-field appearance="outline" fxFlex="auto">
            <mat-label>Tipo de Usuário</mat-label>
            <mat-select [(ngModel)]="filters.userType" name="filterUserType">
              <mat-option [value]="0">Todos</mat-option>
              <mat-option
                *ngFor="let userType of optionsUserType"
                [value]="userType.value"
              >
                {{ userType.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex="100%">
            <mat-label>Nome</mat-label>
            <input
              matInput
              type="text"
              placeholder="Nome"
              [(ngModel)]="filters.userName"
              name="filterUserName"
            />
          </mat-form-field>
        </div>

        <!-- <div class="container__buttom-search" fxLayoutAlign="space-between start" fxLayoutAlign.lt-md="center center"
          fxLayout="row" fxLayout.lt-md="column">
          <a mat-raised-button class="container__buttom-search__btn" (click)="getUsers()">Procurar</a>
          <a mat-raised-button class="container__buttom-search__btn" [routerLink]="['../add']">Novo Usuário</a>
        </div> -->

        <div
          class="container-buttom-search"
          fxLayoutAlign="space-between center"
          fxLayoutAlign.lt-md="center center"
          fxLayout="row"
          fxLayout.lt-md="column"
        >
          <button
            mat-raised-button
            class="container-buttom-search__btn button-mobile"
            (click)="getUsers()"
          >
            Procurar
          </button>
          <button
            mat-raised-button
            class="
              container-buttom-search__btn
              margin-large-screen-right
              button-mobile
            "
            type="button"
            [routerLink]="['../add']"
          >
            Novo Usuário
          </button>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- </mat-expansion-panel> -->
  </form>

  <div class="container" *ngIf="users.length">
    <div fxLayout="row" fxLayoutAlign="space-between start">
      <h3>( {{ users?.length }} ) Usuário(s) encontrado(s)</h3>
    </div>

    <section
      class="container__list column-reverse"
      *ngFor="
        let user of users
          | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage };
        let i = index
      "
    >
      <a
        [routerLink]="['../edit']"
        [queryParams]="{ id: user?.id }"
        class="result__list"
      >
        <mat-card>
          <mat-card-title>{{ user?.name }}</mat-card-title>
          <mat-card-subtitle
            >Perfil: {{ user?.type | userType }}</mat-card-subtitle
          >
          <mat-card-subtitle>Usuário: {{ user?.username }}</mat-card-subtitle>
        </mat-card>
      </a>
    </section>

    <pagination-controls
      *ngIf="users"
      previousLabel="Anterior"
      nextLabel="Próximo"
      class="my-pagination"
      (pageChange)="currentPage = $event"
    ></pagination-controls>
  </div>
</div>
